import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAdminAuth } from "@/context/AdminAuthContext";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminGate() {
    const { token, checked, login } = useAdminAuth();
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);

    if (!checked) {
        return (
            <div className="min-h-screen flex items-center justify-center text-muted-foreground">
                Checking session…
            </div>
        );
    }

    if (token) {
        return <Outlet />;
    }

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await login(username, password);
            toast.success("Welcome back");
        } catch (e) {
            const msg = e?.response?.data?.detail || "Invalid username or password";
            toast.error(msg);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex items-center justify-center px-4">
            <form
                onSubmit={submit}
                data-testid="admin-login-form"
                className="w-full max-w-md bg-card border border-border/60 rounded-3xl p-8 shadow-warm animate-fadeUp"
            >
                <div className="flex items-center gap-3">
                    <div className="h-10 w-10 rounded-full bg-primary/10 flex items-center justify-center">
                        <Lock className="h-5 w-5 text-primary" />
                    </div>
                    <div>
                        <p className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">
                            Merchant
                        </p>
                        <h1 className="font-serif text-2xl">Admin access</h1>
                    </div>
                </div>
                <div className="mt-6 space-y-3">
                    <div>
                        <Label htmlFor="un" className="text-xs uppercase tracking-[0.2em]">
                            Username
                        </Label>
                        <Input
                            id="un"
                            data-testid="admin-username-input"
                            type="text"
                            placeholder="Enter username"
                            value={username}
                            onChange={(e) => setUsername(e.target.value)}
                            className="mt-1 h-12 rounded-2xl"
                            autoFocus
                            autoComplete="username"
                        />
                    </div>
                    <div>
                        <Label htmlFor="pw" className="text-xs uppercase tracking-[0.2em]">
                            Password
                        </Label>
                        <Input
                            id="pw"
                            data-testid="admin-password-input"
                            type="password"
                            placeholder="Enter password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className="mt-1 h-12 rounded-2xl"
                            autoComplete="current-password"
                        />
                    </div>
                </div>
                <Button
                    type="submit"
                    data-testid="admin-login-submit"
                    disabled={loading}
                    className="w-full mt-6 h-12 rounded-full bg-primary hover:bg-primary-hover text-primary-foreground"
                >
                    {loading ? "Signing in…" : "Sign in"}
                </Button>
                <p className="text-xs text-muted-foreground mt-6 text-center">
                    This area is only for the merchant. Ask the store owner for access.
                </p>
            </form>
        </div>
    );
}
